import React, { useContext } from 'react';
import { Variant } from '../../../types';
import { ActivationErrorType, StepId } from '../../../constants';

interface ContextProps {
    isPro: boolean;
    email: string;
    postActivationDelay: number;
    variant: Variant;
    onSkip?: () => void;
    onError?: (error: ActivationErrorType) => void;
    onSuccess?: () => void;
    onClose?: () => void;
    stepId: StepId;
    goToStep: (stepId: StepId) => void;
    setEmail: (email: string) => void;
    initialFocusRef: React.RefObject<HTMLInputElement>;
}

export const CodeActivationContext = React.createContext<ContextProps | undefined>(undefined);

export const useCodeActivationContext = () => {
    const value = useContext(CodeActivationContext);

    if (value === undefined) {
        throw new Error('useCodeActivationContext must be used within a CodeActivationContext.Provider');
    }

    return value;
};
